import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const mqttsession = localStorage.getItem('mqttsession');
if (!mqttsession){
  localStorage.setItem('mqttsession', Date.now().toString())
}


// TEMP: remove after confirming GitHub Actions deployment
console.log('[GITHUB DEPLOY] Deployed via GitHub Actions - production');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
